import CountryTasksTotalBlock from "./CountryTasksTotalBlock";

export default CountryTasksTotalBlock;